
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import { fetchAllFactFiles } from '@/src/utils/fact-file';
import FactFilePage from '../../../src/pages/FactFile';
import { fetchContent, withNavigation } from '../../../src/utils/contentfulHelpers';
const ERROR_REVALIDATE = Number(process.env.REVALIDATION_TIMEOUT_ERROR) || 30;
const DEFAULT_REVALIDATE = Number(process.env.REVALIDATION_TIMEOUT_SHORT) || 60 * 5;
const propTypes = {
    router: PropTypes.shape({
        asPath: PropTypes.string,
        query: PropTypes.shape({
            category: PropTypes.string,
            externalId: PropTypes.string
        })
    }).isRequired,
    content: PropTypes.array.isRequired,
    factFilesData: PropTypes.array.isRequired
};
const FactFile = ({ content, factFilesData }) => {
    return <FactFilePage content={content} factFilesData={factFilesData}/>;
};
async function getStaticProps(context) {
    const { externalId, category } = context?.params;
    const [content, errors] = await fetchContent({
        contentTypes: ['factFilePage'],
        externalId
    });
    if (!content) {
        return { notFound: true, revalidate: ERROR_REVALIDATE };
    }
    if (errors) {
        if (errors.statusCode === 404) {
            return { notFound: true, revalidate: ERROR_REVALIDATE };
        }
        throw new Error(errors.statusMessage);
    }
    if (content[0]?.body.category !== category) {
        return { notFound: true, revalidate: ERROR_REVALIDATE };
    }
    const factFilesData = await fetchAllFactFiles([
        'externalId',
        'contentfulId',
        'category',
        'displayTitle',
    ]);
    const { relatedEntries, bodyText, sidebarText } = content[0]?.body;
    const maxRelatedEntries = 4;
    const finalRelatedEntries = [];
    if (relatedEntries) {
        finalRelatedEntries.push(...relatedEntries);
    }
    // If relatedEntries are less than maxRelatedEntries, use bodyText.linkedEntries
    if (finalRelatedEntries.length < maxRelatedEntries && bodyText && bodyText.linkedEntries) {
        const bodyLinkedEntriesCount = maxRelatedEntries - finalRelatedEntries.length;
        let bodyLinkedEntriesList = bodyText.linkedEntries
            .filter((entry) => entry.contentTypeId === 'factFilePage')
            .slice(0, bodyLinkedEntriesCount);
        // Fetch body linkedEntries
        bodyLinkedEntriesList = await Promise.all(bodyLinkedEntriesList
            .filter((entry) => entry.contentfulId)
            .map(async (entry) => {
            const [response] = await fetchContent({
                contentTypes: ['factFilePage'],
                contentfulIds: [entry.contentfulId]
            });
            return response?.[0]?.body;
        }));
        finalRelatedEntries.push(...bodyLinkedEntriesList.filter((entry) => entry));
    }
    // After using body linkedEntries, if related entries are less than maxRelatedEntries then
    // use sidebarText.linkedEntries
    if (finalRelatedEntries.length < maxRelatedEntries && sidebarText && sidebarText.linkedEntries) {
        const linkedEntriesCount = maxRelatedEntries - finalRelatedEntries.length;
        const { linkedEntries } = sidebarText;
        let sidebarLinkedEntriesList = linkedEntries
            .filter((entry) => entry.contentTypeId === 'factFilePage')
            // Remove duplicates from body linkedEntries
            .filter((entry) => !finalRelatedEntries.some((relatedEntry) => relatedEntry.contentfulId === entry.contentfulId))
            .slice(0, linkedEntriesCount);
        // Fetch sidebar linkedEntries
        sidebarLinkedEntriesList = await Promise.all(sidebarLinkedEntriesList
            .filter((entry) => entry.contentfulId)
            .map(async (entry) => {
            const [response] = await fetchContent({
                contentTypes: ['factFilePage'],
                contentfulIds: [entry.contentfulId]
            });
            return response?.[0]?.body;
        }));
        finalRelatedEntries.push(...sidebarLinkedEntriesList.filter((entry) => entry));
    }
    content[0].body.relatedEntries = finalRelatedEntries;
    const props = await withNavigation({ content, factFilesData });
    return {
        props,
        revalidate: DEFAULT_REVALIDATE
    };
}
export async function getStaticPaths() {
    return {
        fallback: 'blocking',
        paths: []
    };
}
FactFile.propTypes = propTypes;
export default withRouter(FactFile);

    async function __Next_Translate__getStaticProps__195ca0c936e__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/fact-file/[category]/[externalId]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0c936e__ as getStaticProps }
  